if (!customElements.get("bundle-product-block")) {
  class BundleProductBlock extends HTMLElement {
    constructor() {
      super();
      this.bundles = new Bundles();

      this.displayBundleContainer = false;
      this.section = document.querySelector(".bundle-block-container");
      this.bundleContainer = null;
      this.isParentBundle = false;

      this.strings = {};
    }

    initializeComponent() {
      this.bundles.initializeFromElement(this);
      this.bundleContainer = this.querySelector(".bundle-block-container");
    }

    async renderBundle(bundle) {
      const bundleId = bundle.id;
      const bundleHandle = bundle.bap_handle;

      const root = this.bundles.routes?.root || window.Shopify?.routes?.root || "/";
      const url = `${root}products/${bundleHandle}?view=bundle-block`;
      const response = await fetch(url);
      const responseText = await response.text();
      const bundleElement = document.createElement("div");
      bundleElement.className = "bundle-block-item";
      bundleElement.dataset.bundleId = bundleId;
      const dceTitle = this.bundles.container.getAttribute("data-dce-title");
      bundleElement.dataset.dceTitle = dceTitle;
      bundleElement.innerHTML = new DOMParser().parseFromString(responseText, "text/html").body.innerHTML;

      this.bundleContainer.appendChild(bundleElement);

      return bundleElement;
    }

    addEventListeners() {
      const addToCartBtns = this.querySelectorAll(".js--add-to-cart-bundle");
      if (!addToCartBtns || addToCartBtns.length === 0) {
        console.warn("No add-to-cart buttons found");
        return;
      }

      addToCartBtns.forEach((addToCartBtn) => {
        addToCartBtn.addEventListener("click", async (event) => {
          event.preventDefault();
          const bundleId = addToCartBtn.closest(".bundle-block-item")?.dataset?.bundleId;
          if (!bundleId) {
            console.warn("No bundle ID found on button");
            return;
          }
          await this.bundles.addItemsToShopify(bundleId);
          await this.bundles.getShopifyCart();
          await this.bundles.createCartBundle(bundleId);
        });
      });
    }

    initTooltips() {
      const tooltipTriggers = this.querySelectorAll(".aur-tooltip");

      tooltipTriggers.forEach((trigger) => {
        const tooltipContainer = trigger.closest(".aur-tooltip-container");
        if (!tooltipContainer) return;
        const tooltipContent = tooltipContainer.querySelector(".aur-tooltip-content");
        const tooltipExit = tooltipContent?.querySelector(".aur-tooltip-exit");

        trigger.onclick = () => {
          // Hide all tooltips first
          this.querySelectorAll(".aur-tooltip-content.show").forEach((tc) => tc.classList.remove("show"));
          if (tooltipContent) tooltipContent.classList.add("show");
        };

        if (tooltipExit) {
          tooltipExit.onclick = (e) => {
            e.stopPropagation();
            tooltipContent.classList.remove("show");
          };
        }
      });

      document.addEventListener("click", (event) => {
        if (!event.target.closest(".aur-tooltip-container") && !event.target.closest(".aur-tooltip")) {
          document.querySelectorAll(".aur-tooltip-content.show").forEach((tc) => tc.classList.remove("show"));
        }
      });
    }

    async connectedCallback() {
      this.initializeComponent();
      this.bundles.bundleData = await this.bundles.getBundles();
      if (!this.bundles.bundleData || this.bundles.bundleData.length === 0) {
        console.warn("No bundle data found");
        return;
      }

      console.log("Bundle data:", this.bundles.bundleData);

      this.bundles.productData = await this.bundles.getShopifyProductsData();

      console.log("Product data:", this.bundles.productData);

      for (const bundle of this.bundles.bundleData) {
        const isBundleRestricted = await this.bundles.getIsBundleRestricted(bundle.id);
        if (isBundleRestricted) {
          console.warn(`Bundle ${bundle.id} contains restricted products. Skipping rendering.`);
          continue;
        }

        const isBundleOOS = await this.bundles.getIsBundleOOS(bundle.id);
        if (isBundleOOS) {
          console.warn(`Bundle ${bundle.id} is out of stock. Skipping rendering.`);
          continue;
        }

        const getIsBundleTSCRestricted = await this.bundles.getIsBundleTSCRestricted(bundle.id);
        if (getIsBundleTSCRestricted) {
          console.warn(`Bundle ${bundle.id} contains TSC restricted products. Skipping rendering.`);
          continue;
        }

        this.bundles.getShopifyCart();
        this.bundles.createAddToCartobjects(bundle);
        const bundleElement = await this.renderBundle(bundle);
        this.bundles.renderPrice(bundle.id, bundleElement);
        this.bundles.renderDCE(bundle.id, bundleElement);
        // this.bundles.renderCannabinoidClassification(bundle.id, bundleElement);
        // this.bundles.renderPlantType(bundle.id, bundleElement);
        if (!this.displayBundleContainer) {
          this.displayBundleContainer = true;
        }
      }

      this.initTooltips();
      this.addEventListeners();

      if (this.displayBundleContainer && this.bundles.container) {
        this.bundles.container.classList.remove("bundle-product-block--hidden");
      }
    }

    disconnectedCallback() {
      this.bundles.disconnectedCallback();
    }
  }

  customElements.define("bundle-product-block", BundleProductBlock);
}
